import type { TFunction } from 'i18next';

import { quietBannerText, stepLabel } from '../../constants/labels';
import type { HeldCounts, QuietBanner } from '../../hooks/logic/useHeldAlerts';
import type { FeedItem } from '../../types/domain.types';
import { alertLines } from '../shared/alertLines';

export type ShownQuietBanner = Exclude<QuietBanner, { kind: 'hidden' }>;

export const hasHeld = (counts: HeldCounts): boolean => Object.values(counts).some((count) => (count ?? 0) > 0);

export const quietBannerLine = (t: TFunction, banner: ShownQuietBanner): string => quietBannerText(t, banner.until, banner.counts);

export const switchLabel = (t: TFunction): string => t('closeTheLoop.quietHours.toggle', 'Quiet hours');

export const explainer = (t: TFunction, enabled: boolean): string =>
  enabled
    ? t('closeTheLoop.quietHours.explainerOn', 'Minor and Caution wait for your morning email. Major and Emergency still come.')
    : t('closeTheLoop.quietHours.explainerOff', 'Off: every alert reaches you as it happens, day or night.');

export interface HeldRowText {
  readonly title: string;
  readonly beforeTime: readonly string[];
  readonly afterTime: readonly string[];
}

const present = (part: string | null): part is string => part !== null && part !== '';

export const heldRowText = (t: TFunction, item: FeedItem, locale: string): HeldRowText => {
  const lines = alertLines(t, item, locale);
  if (item.status === null) return { title: lines.title, beforeTime: [stepLabel(t, item.step)], afterTime: [] };
  return { title: lines.title, beforeTime: [item.location, lines.reading].filter(present), afterTime: [lines.rowClaim] };
};
